import { render, staticRenderFns } from "./SupplierBatchTable.vue?vue&type=template&id=1d98824e&"
import script from "./SupplierBatchTable.vue?vue&type=script&lang=js&"
export * from "./SupplierBatchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports